export default __webpack_public_path__ + "static/media/manageproduct.a32c54d6.svg";